import { render, staticRenderFns } from "./ErrorGroupList.vue?vue&type=template&id=06d9494d&scoped=true"
import script from "./ErrorGroupList.vue?vue&type=script&lang=js"
export * from "./ErrorGroupList.vue?vue&type=script&lang=js"
import style0 from "./ErrorGroupList.vue?vue&type=style&index=0&id=06d9494d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d9494d",
  null
  
)

export default component.exports